import { Box, Button, Flex, HStack, Text, useColorModeValue } from '@chakra-ui/react'
import { CaretDoubleLeft, CaretDoubleRight, CaretLeft, CaretRight } from '@phosphor-icons/react'
import React from 'react'

interface Props {
    total: number,
    perPage: number,
    current: number,
    setCurrentPage: any
}

interface PageBoxProps {
    item: React.ReactNode,
    isActive?: boolean
    action: any
}

const calculatePages = (total: number, perPage: number, currentPage: number) => {
    const totalPages = Math.ceil(total / perPage);
    const pageNumbers = [];
    const maxPagesToShow = 5;

    let startPage = Math.max(1, Math.min(currentPage - Math.floor(maxPagesToShow / 2), totalPages - maxPagesToShow + 1));
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

    for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push({ pageNumber: i })
    }

    return pageNumbers;
}

const PageBox = ({ item, isActive, action }: PageBoxProps) => {
    const fontColor = useColorModeValue("black", "white");
    const borderColor = useColorModeValue("green.600", "green.300");

    return (
        <Button
            justifyContent="center"
            alignItems="center"
            w="40px"
            h="40px"
            border="1px solid"
            borderColor={isActive ? borderColor : "gray.400"}
            borderRadius="none"
            variant={isActive ? "solid" : "outline"}
            cursor="pointer"
            backgroundColor={isActive ? 'health.primary' : 'transparent'}
            color={isActive ? "white" : fontColor}
            onClick={action}
            _focus={{ outline: 'none' }}
        >
            {item}
        </Button>
    )
}

const Paginator = ({ total, perPage, current, setCurrentPage }: Props) => {
    const pages = calculatePages(total, perPage, current);

    const OnPage = (toPage: number) => {
        if (toPage > Math.ceil(total / perPage)) setCurrentPage(Math.ceil(total / perPage))
        else if (toPage < 1) setCurrentPage(1)
        else setCurrentPage(toPage)
    }

    return (
        <Flex >
            <PageBox action={() => OnPage(1)} item={<Box><CaretDoubleLeft size="15" /></Box>} />
            <PageBox action={() => OnPage(current - 1)} item={<Box><CaretLeft size="15" /></Box>} />
            {
                pages.map(page => <PageBox key={page.pageNumber} action={() => OnPage(page.pageNumber)} item={<Text fontWeight="normal">{page.pageNumber}</Text>} isActive={current === page.pageNumber} />)
            }
            <PageBox action={() => OnPage(current + 1)} item={<Box><CaretRight size="15" /></Box>} />
            <PageBox action={() => OnPage(Math.ceil(total / perPage))} item={<Box><CaretDoubleRight size="15" /></Box>} />
        </Flex>
    )
}

export default Paginator